import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingBottom: 20,
    },
    holidaySettingsView: {
      width: '50%',
      padding: '0 20px 20px 0',
      [theme.breakpoints.down(Sizes.tablet)]: {
        width: '100%',
        padding: '20px 0',
      },
    },
    addBtn: {
      cursor: 'pointer',
      color: colorVariables.blue,
      display: 'flex',
      alignItems: 'center',
      fontSize: 13,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 11,
        textTransform: 'uppercase',
        fontWeight: 700,
      },
    },
    addBtnHolidays: {
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'row-reverse',
        transform: 'translateY(-35px)',
      },
    },
    addIcon: {
      marginRight: 7,
      fontSize: 24,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginRight: 0,
        marginLeft: 5,
        fontSize: 22,
      },
    },
    closeIconWrap: {
      width: 18,
      height: 18,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      border: '1px solid #DADADA',
      cursor: 'pointer',
      position: 'absolute',
      right: 5,
      top: 1,
      backgroundColor: colorVariables.white,
      boxShadow: '0 0 0 6px #ffffff',
      '&:hover': {
        border: `1px solid ${colorVariables.grey60}`,
      },
      '&:hover svg': {
        color: colorVariables.grey60,
      },
    },
    closeIcon: {
      color: '#DADADA',
      fontSize: 14,
    },
    track: {
      backgroundColor: colorVariables.steelGrey,
      opacity: 1,
    },
    thumb: {
      backgroundColor: colorVariables.white,
      width: 20,
      height: 20,
    },
    checked: {
      '&.MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#44B5E6',
        opacity: 1,
      },
    },
    holidaysBlock: {
      display: 'flex',
      alignItems: 'center',
    },
    holidaysLabel: {
      fontSize: 12,
      textTransform: 'uppercase',
      fontWeight: 700,
      lineHeight: '24px',
      marginRight: 15,
    },
    holidaysContent: {
      paddingTop: 5,
    },
    holidaysContentHead: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 15,
    },
    holidaysTitle: {
      fontSize: 13,
      color: colorVariables.grey80,
      width: 290,
    },
    dateItem: {
      fontSize: 16,
      color: colorVariables.grey80,
      width: 50,
      display: 'inline-block',
      marginRight: 7,
      marginBottom: 7,
    },
    holidaysModal: {
      padding: '45px 30px 20px 30px',
      width: 820,
      [theme.breakpoints.down(Sizes.tablet)]: {
        padding: '45px 25px 20px 25px',
        width: 600,
      },
    },
    holidaysModalHead: {
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: 50,
    },
    holidaysModalTitle: {
      fontSize: 20,
      fontWeight: 700,
    },
    holidaysSubtitle: {
      fontSize: 13,
      color: colorVariables.grey80,
      paddingLeft: 25,
    },
    holidaysModalContent: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 30,
      '&>div': {
        width: '47%',
      },
    },
    holidaysListHead: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 15,
      backgroundColor: 'rgba(152, 165, 183, 0.15)',
    },
    holidaysListTitle: {
      color: '#98A5B7',
      fontSize: 11,
      textTransform: 'uppercase',
      fontWeight: 700,
    },
    holidaysListBox: {
      backgroundColor: 'rgba(152, 165, 183, 0.04)',
      padding: 15,
      height: 305,
      overflowY: 'scroll',
    },
    holidaysBtns: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    holidaysCell: {
      position: 'relative',
      display: 'inline-flex',
      width: 65,
      height: 26,
      marginRight: 10,
    },
  }),
);
